<template>
  <div>
    <div style="position: sticky; top:0px;z-index: 99; padding: 5px; background-color: #000;"><!-- background-color:#fff; -->
      <el-row :span="24" type="flex" style="" align="middle">
        <el-col :span="3" style="padding-left: 5px;font-size: 20px;color: #fff;">
          <i @click="showTopMenu()" class="el-icon-s-unfold" style="padding-right: 10px;"></i>
        </el-col>
        <el-col :span="6" style="font-size: 20px;color: #fff;">
          <a href="/"><img height="70" src="@/assets/logo.png" fit="contain"></a>
        </el-col>
        <el-col :span="13" style="text-align: center;color: #fff;">

          <a class="neon-text" href="https://t.me/toon825" target="_blank">배너문의</a> & <a class="neon-text" href="https://t.me/toon825" target="_blank">대피소</a>

        </el-col>
        <el-col :span="4" style="text-align: right;padding-right: 5px;font-size: 20px;color: #fff;">
          <i @click="showTopSearch()" class="el-icon-search" style="margin-left: 20px;"></i>
        </el-col>
      </el-row>
    </div>

    <el-row style="color: #ffd700;"><!-- background-color:#fff; -->
      <el-col :span="24" :xs="24" :sm="0">

        <el-container style="width: 100%;overflow: auto; ">
          <el-main>
            <div style="white-space: nowrap;" class="font_mhbson">
              <!-- <router-link to="PageSearchTop"><i class="el-icon-medal-1"></i> <span style="margin-right: 20px;">인기검색순</span></router-link> -->
              <router-link to="PageType?type=1"><i class="el-icon-s-ticket"></i> <span style="margin-right: 20px;">영화</span></router-link>
              <router-link to="PageType?type=2"><i class="el-icon-video-camera-solid"></i> <span style="margin-right: 20px;">드라마</span></router-link>
              <router-link to="PageType?type=3"><i class="el-icon-s-flag"></i> <span style="margin-right: 20px;">예능</span></router-link>
              <router-link to="PageType?type=4"><i class="el-icon-s-opportunity"></i> <span style="margin-right: 20px;">시사</span></router-link>
              <router-link to="PageType?type=5"><i class="el-icon-bicycle"></i> <span style="margin-right: 20px;">애니메이션</span></router-link>
              <router-link to="PageType?type=6"><i class="el-icon-hot-water"></i> <span style="margin-right: 20px;">OTT예능</span></router-link>
              <router-link to="PageType?type=9"><i class="el-icon-s-shop"></i> <span style="margin-right: 20px;">지난드라마</span></router-link>
              <!-- <router-link to="PageUpdate"><i class="el-icon-upload"></i> <span style="margin-right: 20px;">최신업데이트</span></router-link> -->
            </div>
          </el-main>
        </el-container>

      </el-col>
    </el-row>

    
  </div>
</template>

<script>
export default {
  name: 'TopSearch_m',
  data(){
    return {
      
    }
  },
  props: {

  },
  methods:{
    showTopMenu(){
      this.$emit('showTopMenu', true)
    },
    showTopSearch(){
      this.$emit('showTopSearch', true)
    }
  }
}
</script>


<style>
  
</style>
